/**************************************************
 * Nombre:       Dialogo_Detalle_Campana_Info
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {useContext, useState} from "react";
import {usuarioContext} from "../../App";
import Tarjeta_Funnel_Pq from "../Tarjetas/Tarjeta_Funnel_Pq";
import Formulario_Detalle_Campana_Info from "../Formularios/Formulario_Detalle_Campana_Info";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {Delete} from "@mui/icons-material";
import dayjs from "dayjs";

const Dialogo_Detalle_Campana_Info = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })
    const [numSaldo, setNumSaldo] = useState(0)


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()


        if (entidad.estado === 'Activo' && !entidad.fechaFin ){
            entidad.fechaFin = dayjs().add(entidad.numDias, 'days').valueOf()
        }

        iniciarCarga('Subiendo Datos')


        let dox = await guardarDoc('campanas', entidad)
        if (dox.res) {

            terminar({aviso: 'Datos subidos con exito'})
            realizado()
            cerrar()

        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('campanas', datos.id)
        terminar({aviso: 'Campaña borrada'})
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Tarjeta_Funnel_Pq item={datos}/>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-start', mt: 2}}>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                <Formulario_Detalle_Campana_Info props={props}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Detalle_Campana_Info